import { useQuery } from "@tanstack/react-query";

import { DefaultFetchService } from "app/services/fetchService";
import type { IAccountUsersResponse, IShareUser } from "app/sharing/SharingService";
import { accountUsersUrl } from "app/sharing/SharingService";

const fetchService = DefaultFetchService.getInstance();

export const useAccountUsersQuery = () => {
    const { data, isLoading, error } = useQuery({
        queryKey: ["accountUsers"],
        queryFn: () => fetchService.get<IAccountUsersResponse>(accountUsersUrl, {}, { preventAutoCancellation: true }),
        select: (response: IAccountUsersResponse): IShareUser[] =>
            response.users.map((user) => ({
                ...user,
                user: `${user.firstName} ${user.lastName}`,
            })),
    });
    return { accountUsers: data, isAccountUsersLoading: isLoading, accountUsersError: error };
};
